/**
 * External XR Trigger
 *
 * This script adds an event listener to a button or element
 * to trigger the XR experience using the global triggerXRButton function.
 * It also closes the menu if it's open.
 */
class ExternalXRButton {
  constructor(el) {
    this.init(el);
  }

  init(el) {
    if(el.agog_initialized === undefined) {
      el.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Close menu if it's open
        if (document.body.classList.contains('js--menu-active')) {
          const menuToggle = document.querySelector('.js--menu-toggle');
          if (menuToggle) {
            menuToggle.click();
          }
        }
        
        // Check if the global triggerXRButton function exists
        if (typeof window.triggerXRButton === 'function') {
          // Trigger the XR button click
          window.triggerXRButton();
        } else {
          console.error('triggerXRButton function not found. Make sure the XRButton component is mounted.');
        }
      });
      el.agog_initialized = true;
    }
  }
}

export default ExternalXRButton;
